import React, { FunctionComponent, ReactElement, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box, Flex, Image } from "@familyzone/component-library";
import { NavRightActions } from "./NavRightActions";
import { AnnouncementBar } from "js/components/AnnouncementBar";
import Chatbot from "js/components/Chatbot";
import LogoClasswize from "assets/Icon_navlogo.svg?url";
import LogoSmoothwall from "assets/Icon_navlogoSmoothwall.svg?url";
import IconHome from "assets/IconHome.svg?url";
import { useThemeStore } from "stores/v2/themeStore";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { getClassroomDisplayName } from "@/utils/classroomUtils";
import { ClassroomOverviewDTO } from "@/stores/classroomStore_I";

type Classroom = {
	// (Slimmed down to only what this component needs)
	description: string;
	name: string;
	personalisation?: {
		displayName: string;
	};
	type: "CLASSROOM" | "GROUP";
};

interface Props {
	selectedClass?: Classroom;
}

const Nav: FunctionComponent<Props> = (props): ReactElement => {
	const navigate = useNavigate();
	const [selectedClassName, setSelectedClassName] = useState<string>("");
	const themeStore = useThemeStore();

	useEffect(() => {
		if (props.selectedClass) {
			setSelectedClassName(getClassroomDisplayName(props.selectedClass as ClassroomOverviewDTO));
		}
	}, [props.selectedClass]);

	return (
		<Box>
			<AnnouncementBar key={"announcement-bar"} />
			<header>
				<Flex justifyContent={"space-between"} id="navbar">
					<Flex>
						<Box
							as="button"
							onClick={() => {
								navigate("/classrooms/overview");
							}}
							className="nav-logo"
							aria-label="Classwize"
						>
							<Image src={themeStore.theme === "smoothwall" ? LogoSmoothwall : LogoClasswize} alt="" px={14} py={14} aria-hidden="true" />
						</Box>
						<Breadcrumb className="breadcrumb">
							<BreadcrumbItem>
								<BreadcrumbLink as={Link} to="/classrooms/overview">
									<Image className="NavIconHome" src={IconHome} mr={8} alt="" />
									My Classes
								</BreadcrumbLink>
							</BreadcrumbItem>
							{selectedClassName !== "" && (
								<>
									<BreadcrumbItem>
										<BreadcrumbLink className="current-link" data-test="breadcrumb-selected-classroom" isCurrentPage>
											{selectedClassName}
										</BreadcrumbLink>
									</BreadcrumbItem>
								</>
							)}
						</Breadcrumb>
					</Flex>
					<NavRightActions classroomName={selectedClassName} />
				</Flex>
			</header>
			<Chatbot />
		</Box>
	);
};

export default Nav;
